import { IIntegrationAccountResponse } from "@wingspanhq/integrations/dist/lib/interfaces/account";
import { IIntegrationCustomer } from "@wingspanhq/integrations/dist/lib/interfaces/customer";
import { IIntegrationItemResponse } from "@wingspanhq/integrations/dist/lib/interfaces";
import { IIntegrationsQuickbooksResponse } from "@wingspanhq/integrations/dist/lib/interfaces/quickbooks-api/integrationsQuickbooks";
import { IIntegrationVendor } from "@wingspanhq/integrations/dist/lib/interfaces/vendor";
import { IFeatureFlags } from "../../../query/hooks/useFeatureFlags";
import { selectorIsQBOActive } from "../../../shared/selectors/selectorIsQBOActive";

export interface PayeeQboMappingInput {
  featureFlags?: IFeatureFlags;
  qboService?: IIntegrationsQuickbooksResponse;
  vendors?: (IIntegrationVendor | IIntegrationCustomer)[];
  expenseAccounts?: (IIntegrationAccountResponse | IIntegrationItemResponse)[];
}

export const selectorIsPayeeQboMappingEnabled = ({
  featureFlags,
  qboService,
  vendors,
  expenseAccounts
}: PayeeQboMappingInput): boolean =>
  Boolean(
    selectorIsQBOActive(featureFlags, qboService) &&
    (vendors?.length ?? 0) > 0 &&
    (expenseAccounts?.length ?? 0) > 0
  );
